<template>
  <div class="project-user-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            v-model="name"
            placeholder="用户名"
            style="width: 100%"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only"
          v-model="name"
          placeholder="用户名"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('sys:user:delete')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('sys:user:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              用户名
            </vs-th>
            <vs-th>
              邮箱
            </vs-th>
            <vs-th>
              手机号
            </vs-th>
            <vs-th>
              状态
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.userId}}
              </vs-td>
              <vs-td>
                {{tr.username}}
              </vs-td>
              <vs-td>
                {{tr.email}}
              </vs-td>
              <vs-td>
                {{tr.mobile}}
              </vs-td>
              <vs-td>
                <span
                  class="self-tag"
                  :style="getStyle(tr)"
                >{{getStatus(tr)}}</span>
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:user:update')"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:user:delete')"
                  class="delete-btn"
                  @click="deleteHandle(tr.userId)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-dialog
      :dialog-show="addUserDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-dialog>
    <edit-user-dialog
      :user-id="currentUserId"
      :dialog-show="editUserDialogShow"
      @close="closeEditDialog"
      @edit-success="editUserSuccess"
    ></edit-user-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editUserDialog from '@/components/sys/userList/editUserDialog'
import addDialog from "@/components/sys/userList/addDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import { deleteUser } from "@/api/sys/userList";
export default {
  name: "index",
  components: {
    addDialog,
    editUserDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      typeList: [],
      red: '#D85E5F',
      green: '#41B883',
      addUserDialogShow: false,
      editUserDialogShow: false,
      currentUserId: 0,
      ids: []
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  mounted(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/user/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'user_id',
        order: 'desc'
      }

      if(this.name){
        this.params.username = this.name;
      }
      return true;
    },
    addHandle(){
      this.addUserDialogShow = true;
    },
    addUserSuccess(){
      this.addUserDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentUserId = row.userId;
      setTimeout(() => {
        this.editUserDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editUserDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.editUserDialogShow = false;
    },
    deleteHandle(id){
      this.ids = id ? [id] : this.selected.map(item => item.userId);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
        deleteUser(ids).then((res) => {
          this.$message({
            type: 'success',
            message: '已删除'
          });
          this.$refs.muldelete.dialogShow = false;
          this.searchHandle();
        })
    },
    closeAddDialog(){
      this.addUserDialogShow = false;
    },

    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
